import { render, staticRenderFns } from "./widget-render.vue?vue&type=template&id=a9a4d2a2"
import script from "./widget-render.vue?vue&type=script&lang=js"
export * from "./widget-render.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports